export default ($locationProvider, $routeProvider, $windowProvider) => {
    'ngInject';
    $locationProvider.html5Mode(true);
    let $window = $windowProvider.$get();
    if(!$window.disableOutput) {
        $routeProvider
            .when('/outputs/:subModuleName', {
                redirectTo: '/outputs/newsletters'
            })
            .when('/outputs', {
                redirectTo: '/outputs/newsletters'
            });
    }
};



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/default.route.config.ts
 **/